import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from '../EditProfile.module.css';
import type { UploadWorkCardProps } from '../types';

const UploadWorkCard: React.FC<UploadWorkCardProps> = () => {
  const navigate = useNavigate();

  // 跳转到上传指南页面
  const handleUploadClick = () => {
    navigate('/upload/guidelines', { state: { from: 'edit-profile' } });
  };

  return (
    <div className={styles.card}>
      <div
        className={`${styles.uploadArea} ${styles.uploadAreaClickable}`}
        onClick={handleUploadClick}
        style={{ cursor: 'pointer' }}
      >
        <svg
          className={styles.uploadIcon}
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12'
          />
        </svg>
        <p className={styles.sectionTitle}>Click to upload new work</p>
      </div>
    </div>
  );
};

export default UploadWorkCard;
